const upload = (uploadFunc, file) => {
  return new Promise((resolve, reject) => {
    uploadFunc(file, ({ data, error }) => {
      if (error) {
        reject(error);
      } else {
        resolve({ data });
      }
    });
  });
};
export {
  upload
};
//# sourceMappingURL=upload.js.map
